import { useEffect } from 'react'

import { useFetch } from '@reveni-io/reveni-ui'

import useWebsocketAction from '@/common/hooks/useWebsocketAction/useWebsocketAction'
import { getFilterParams } from '@/metrics/helpers/helpers'
import metricsServices from '@/metrics/services/services'

import { errorState } from './constants'
import { transformResponseGetCustomerNotesAnalysis } from './transformers'

const useCustomerNotesAnalysis = ({ reasonId, storeId, filters, doRequest = true }) => {
  const { data, fetchData, setData } = useFetch(metricsServices.getCustomerNotesAnalysis, {
    doInitialRequest: false,
    transformResponse: transformResponseGetCustomerNotesAnalysis,
  })

  const fetchAnalysis = async () => {
    try {
      await fetchData({ reasonId, storeId, params: getFilterParams(filters) })
    } catch {
      setData(errorState)
    }
  }

  const argsSignature = JSON.stringify({ reasonId, storeId, filters })

  useEffect(() => {
    if (!doRequest) return

    fetchAnalysis()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [argsSignature, doRequest])

  useWebsocketAction({
    websocketUrl: data?.websocket_url,
    onComplete: fetchAnalysis,
    onError: () => setData(errorState),
  })

  return { data, refetch: fetchAnalysis }
}

export default useCustomerNotesAnalysis
